import { MeetingsScheduleInterface } from "@api/models/interfaces/meetings-schedule/MeetingsScheduleInterface";
import { DateTime } from "luxon";
import { setDates } from "../helpers/DatesSetter";

export class MeetingsSchedule implements MeetingsScheduleInterface {

    id: string;
    userIds?: number[];
    eventId?: string;
    from: DateTime;
    to: DateTime;
    slotSize?: number;
    parentId?: string;
    meetingId?: string;
    title: string;

    private static dates: string[] = ['from', 'to'];

    constructor(source: MeetingsScheduleInterface) {
        Object.assign(this, source);
        setDates(this, MeetingsSchedule.dates);
    }
}